import { Listbox } from "@headlessui/react";
import React, { useState, useEffect } from 'react';
import { Package, ChevronDown, Info, MapPin, Calendar, Clock, Box, User, Phone, CheckCircle2, Loader2 } from 'lucide-react';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import { useMyContext } from '../../../context/MyContext';
import { toast } from 'react-toastify';
import '../../../css/custom-scrollbar.css'
import { Base_Url, createpickuprequest, b2bWarehouseListAll, pickrequestList } from '../../../config/config';

const PickupDetailsPage = () => {
    const [query, setQuery] = useState("");
    const [dates, setDates] = useState([]);
    const { isDarkMode, isToggleSidebar, selectedCft } = useMyContext();
    const [warehouses, setWarehouses] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState('');
    const [selectedCourier, setSelectedCourier] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);
    const [boxCount, setBoxCount] = useState('');
    const [selectedSlot, setSelectedSlot] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [pickupRequests, setPickupRequests] = useState([]);
    //   const [loading, setLoading] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const limitNumber = 10;

    const token = localStorage.getItem("token");
    const cus_id = localStorage.getItem("cus_id");


    useEffect(() => {
        fetchPickupRequests(currentPage);
    }, [currentPage]);

    const fetchPickupRequests = async (pageNumber) => {
        setLoading(true);
        try {
            const url = `${Base_Url}${pickrequestList}?page=${pageNumber}&limit=${limitNumber}`;

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    cus_id: cus_id,
                    token: token,
                },
            });

            const result = await response.json();

            if (result.status === 'SUCCESS' && result.data) {
                setPickupRequests(result.data);
                setTotalPages(result.pagination.totalPages);
                setTotalItems(result.pagination.totalItems);
            } else {
                console.error('Failed to fetch pickup requests:', result.message);
                setPickupRequests([]);
            }
        } catch (error) {
            console.error('Error fetching pickup requests:', error);
            setPickupRequests([]);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'created':
                return 'bg-red-600 text-white ';
            case 'pending':
                return 'bg-white text-black border-black border-dashed';
            case 'completed':
                return 'bg-black text-white border-black';
            case 'cancelled':
                return 'bg-white text-gray-400 border-gray-300 line-through';
            default:
                return 'bg-white text-gray-600 border-gray-300';
        }
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    useEffect(() => {
        fetchWarehouses();
    }, []);


    useEffect(() => {
        setDates(generateDates());
    }, []);

    const fetchWarehouses = async () => {
        try {
            // Uncomment this for real API
            const response = await fetch(Base_Url + b2bWarehouseListAll, {
                method: "GET",
                headers: {
                    "token": token,
                    "cus_id": cus_id,
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            if (data.status === 'SUCCESS' && data.data) {
                setWarehouses(data.data);
            }
        } catch (error) {
            console.error('Error fetching warehouses:', error);
        } finally {
            setLoading(false);
        }
    };


    const getRandomTimeInSlot = (slot) => {
        const startHour = slot.start;
        const endHour = slot.end;

        const randomHour = Math.floor(Math.random() * (endHour - startHour)) + startHour;
        const randomMinute = Math.floor(Math.random() * 60);

        return `${String(randomHour).padStart(2, "0")}:${String(randomMinute).padStart(2, "0")}:00`;
    };


    const handleCreateRequest = async () => {
        if (!selectedSlot) {
            toast.error("Please select a pickup slot");
            return;
        }
        const slot = pickupSlots.find((s) => s.value === selectedSlot);
        if (!slot) {
            toast.error("Invalid slot");
            return;
        }
            console.log("Submitting warehouse_id:", selectedOrder); // 👈 ye add karo

        setIsSubmitting(true);
        try {
            // Convert date
            const selectedFullDate = new Date();
            selectedFullDate.setDate(selectedFullDate.getDate() + selectedDate);

            const pickupDateFormatted = selectedFullDate.toISOString().split("T")[0];

            // Generate random time inside slot
            const pickupStartTime = getRandomTimeInSlot(slot);

            const requestData = {
                warehouse_id: selectedOrder,
                pickup_date: pickupDateFormatted,
                start_time: pickupStartTime,
                retailer_id: cus_id,
                // contact_person: contactName,
                // contact_phone: contactPhone,
                box_count: parseInt(boxCount),
                courier_partner: selectedCourier,
                type: selectedCft || ''
            };
            const response = await fetch(Base_Url + createpickuprequest, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "cus_id": localStorage.getItem("cus_id"),
                    "token": localStorage.getItem("token"),
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();

            if (data.status === "success") {
                toast.success(data.message);
                setSelectedDate(null);
                setSelectedSlot("");
                setBoxCount("");
                // setContactName("");
                // setContactPhone("");
            } else {
                toast.error(data.message || "Failed to create pickup request");
            }
        } catch (error) {
            console.error("Error creating pickup request:", error);
            toast.error("An error occurred while creating the pickup request");
        } finally {
            setIsSubmitting(false);
        }
    };

    // ✅ selectedCft (number: 6/10/15) ko warehouse ke cft_type (text: lite/heavy/dense) se map kiya
    const cftTypeMap = { 6: "lite", 10: "heavy", 15: "dense" };

    const filteredWarehouses = warehouses.filter((warehouse) => {
        // const billing = JSON.parse(warehouse.billing_address || "{}");
        // const dropoff = JSON.parse(warehouse.dropoff_location || "{}");
        const text = `
        ${warehouse.warehouse_id}
        ${warehouse?.retailer_id}
        ${warehouse?.name}
        ${warehouse.pin_code}
    `.toLowerCase();

        const matchesSearch = text.includes(query.toLowerCase());
        const matchesCft = !selectedCft || warehouse.cft_type?.toLowerCase() === cftTypeMap[selectedCft];

        return matchesSearch && matchesCft;
    });

    const generateDates = (daysCount = 6) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        const today = new Date();
        const result = [];

        for (let i = 0; i < daysCount; i++) {
            const current = new Date();
            current.setDate(today.getDate() + i);

            result.push({
                day: i === 0 ? "Today" : days[current.getDay()],
                date: current.getDate(),
                month: months[current.getMonth()]
            });
        }

        return result;
    };

    const pickupSlots = [
        { value: 'morning', label: 'Morning (7 AM - 10 PM)', start: 7, end: 10 },
        { value: 'morning', label: 'Morning (10 AM - 2 PM)', start: 10, end: 14 },
        { value: 'evening', label: 'Evening (2 PM - 6 PM)', start: 14, end: 18 },
        { value: 'night1', label: 'Night (6 PM - 9 PM)', start: 18, end: 21 },
        { value: 'night2', label: 'Night (9 PM - 12 AM)', start: 21, end: 24 }
    ];
 const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
    return (
        <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
           <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

      <NavBar />

      <div className="flex flex-1 overflow-hidden">

        {isToggleSidebar && (
          <div className={`w-64 m-3 rounded-3xl ${glass} overflow-hidden`}>
            <Sidebar />
          </div>
        )}
                {/* <div className="flex-1 max-w-7xl overflow-y-auto"> */}
                <div
                    className={`flex-1 p-2 overflow-auto transition-all duration-300 custom-scrollbar ${isToggleSidebar ? 'md:ml-0' : 'md:ml-0'} ${isDarkMode ? "dark:bg-black dark:text-white" : "bg-gray-200"}`}
                >
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                        {/* Main Form Section */}
                        <div className="lg:col-span-1">
                            <div className="bg-white rounded-xl border border-gray-200 p-4">

                                <div className="flex items-center gap-2.5 mb-2 pb-1 border-b border-gray-100">
                                    <div className="p-1.5 bg-black rounded-lg">
                                        <Package className="w-4 h-4 text-white" />
                                    </div>
                                    <h2 className="text-[13px] font-semibold text-black tracking-tight uppercase">Pickup Details</h2>
                                </div>

                                {/* Select Order */}
                                <div className="flex gap-3 w-full">

                                    {/* WAREHOUSE DROPDOWN — FIRST */}
                                    <div className="flex-1">
                                        <label className="text-[8px] font-medium text-gray-500 mb-1 block uppercase tracking-wide">
                                            Select Warehouse
                                        </label>

                                        <div className="relative">
                                            <Listbox value={selectedOrder} onChange={setSelectedOrder}>
                                                <div className="relative">

                                                    {/* Button */}
                                                    <Listbox.Button className="w-full px-2.5 py-1.5 bg-white border border-gray-300 rounded-md flex justify-between items-center text-[11px] text-black hover:border-black transition-colors">
                                                        <span className={selectedOrder ? "text-black" : "text-gray-400"}>
                                                            {selectedOrder || "Select Warehouse"}
                                                        </span>
                                                        <ChevronDown className="w-3.5 h-3.5 text-gray-400" />
                                                    </Listbox.Button>

                                                    {/* Dropdown */}
                                                    <Listbox.Options className="absolute z-50 mt-1.5 w-full bg-white border border-black rounded-md shadow-[0_4px_20px_rgba(0,0,0,0.08)] max-h-64 overflow-auto">

                                                        {/* Search Box */}
                                                        <div className="sticky top-0 bg-white p-1.5 border-b border-gray-100">
                                                            <input
                                                                type="text"
                                                                placeholder="Search Warehouse..."
                                                                value={query}
                                                                onChange={(e) => setQuery(e.target.value)}
                                                                className="w-full px-2 py-1 border border-gray-200 rounded text-[11px] focus:outline-none focus:border-black"
                                                            />
                                                        </div>

                                                        {/* Options */}
                                                        {filteredWarehouses.length === 0 ? (
                                                            <p className="p-3 text-[11px] text-gray-400 text-center">No results found</p>
                                                        ) : (
                                                            filteredWarehouses.map((warehouse) => (
                                                                <Listbox.Option
                                                                    key={warehouse.warehouse_id}
                                                                    value={warehouse.warehouse_id}
                                                                    className={({ active }) =>
                                                                        `cursor-pointer px-2.5 py-1.5 border-b border-gray-50 last:border-none text-[11px] ${active ? "bg-black text-white" : "text-black"
                                                                        }`
                                                                    }
                                                                >
                                                                    {({ active }) => (
                                                                        <>
                                                                            <p className="font-semibold">
                                                                                {warehouse.warehouse_id}
                                                                            </p>
                                                                            <p className={`text-[9px] ${active ? "text-gray-300" : "text-gray-500"}`}>
                                                                                {warehouse.retailer_id} • {warehouse.name}
                                                                            </p>
                                                                            <p className={`text-[9px] ${active ? "text-gray-300" : "text-gray-500"}`}>
                                                                                pin {warehouse.pin_code}
                                                                            </p>
                                                                        </>
                                                                    )}
                                                                </Listbox.Option>
                                                            ))
                                                        )}
                                                    </Listbox.Options>
                                                </div>
                                            </Listbox>

                                            {loading && (
                                                <Loader2 className="absolute right-8 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 animate-spin" />
                                            )}
                                        </div>
                                    </div>

                                    {/* COURIER DROPDOWN — SECOND */}
                                    <div className="flex-1">
                                        <label className="text-[8px] font-medium text-gray-500 mb-1 block uppercase tracking-wide">
                                            Select Courier
                                        </label>

                                        <div className="relative">
                                            <Listbox value={selectedCourier} onChange={setSelectedCourier}>
                                                <div className="relative">
                                                    <Listbox.Button className="w-full px-2.5 py-1.5 bg-white border border-gray-300 rounded-md flex justify-between items-center text-[11px] text-black hover:border-black transition-colors">
                                                        <span className={selectedCourier ? "text-black" : "text-gray-400"}>
                                                            {selectedCourier || "Select Courier"}
                                                        </span>
                                                        <ChevronDown className="w-3.5 h-3.5 text-gray-400" />
                                                    </Listbox.Button>

                                                    <Listbox.Options className="absolute z-50 mt-1.5 w-full bg-white border border-black rounded-md shadow-[0_4px_20px_rgba(0,0,0,0.08)] max-h-60 overflow-auto">
                                                        {["Delhivery", "XpressBees", "Gati", "BlueDart", "Ecom Express"].map((option) => (
                                                            <Listbox.Option
                                                                key={option}
                                                                value={option}
                                                                className={({ active }) =>
                                                                    `cursor-pointer px-2.5 py-1.5 border-b border-gray-50 last:border-none text-[11px] ${active ? "bg-black text-white" : "text-black"
                                                                    }`
                                                                }
                                                            >
                                                                {option}
                                                            </Listbox.Option>
                                                        ))}
                                                    </Listbox.Options>
                                                </div>
                                            </Listbox>
                                        </div>
                                    </div>

                                </div>


                                {/* Pickup Date */}
                                <div className="mb-5 mt-2">
                                    <label className="block text-[8px] font-medium text-gray-500 mb-2 uppercase tracking-wide">
                                        Pickup Date
                                    </label>

                                    <div className="grid grid-cols-3 md:grid-cols-6 gap-1.5">
                                        {dates.map((dateInfo, index) => (
                                            <button
                                                key={index}
                                                onClick={() => setSelectedDate(index)}
                                                className={`flex flex-col items-center py-2 rounded-md border text-[10px] transition-all ${selectedDate === index
                                                    ? "border-black bg-black"
                                                    : "border-gray-200 hover:border-black bg-white"
                                                    }`}
                                            >
                                                <span className={`${selectedDate === index ? "text-gray-300" : "text-gray-400"}`}>
                                                    {dateInfo.day}
                                                </span>
                                                <span className={`text-base font-bold leading-tight ${selectedDate === index ? "text-white" : "text-black"}`}>
                                                    {dateInfo.date}
                                                </span>
                                                <span className={`${selectedDate === index ? "text-gray-300" : "text-gray-400"}`}>
                                                    {dateInfo.month}
                                                </span>
                                            </button>
                                        ))}
                                    </div>

                                    <div className="flex items-start gap-1.5 mt-2.5 p-2 bg-gray-50 border border-gray-200 rounded-md">
                                        <Info className="w-3 h-3 text-black mt-0.5 flex-shrink-0" />
                                        <p className="text-[10px] text-gray-600">
                                            Book before 2 PM for same-day pickup.
                                        </p>
                                    </div>
                                </div>

                                {/* Pickup Slot + Boxes */}
                                <div className="mb-5">
                                    <div className="flex flex-col md:flex-row md:items-center md:gap-4">

                                        {/* Time Slot */}
                                        <div className="flex-1 mb-3 md:mb-0">
                                            <label className="block text-[8px] font-medium text-gray-500 mb-2 uppercase tracking-wide">
                                                Pickup Time Slot
                                            </label>
                                            <div className="relative">
                                                <select
                                                    value={selectedSlot}
                                                    onChange={(e) => setSelectedSlot(e.target.value)}
                                                    className="w-full px-2.5 py-1.5 bg-white border border-gray-300 rounded-md text-[11px] text-black focus:outline-none focus:border-black appearance-none"
                                                >
                                                    <option value="">Select a time slot</option>
                                                    {pickupSlots.map((slot) => (
                                                        <option key={slot.value} value={slot.value}>
                                                            {slot.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <ChevronDown className="absolute right-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400 pointer-events-none" />
                                            </div>
                                        </div>

                                        {/* Boxes */}
                                        <div className="flex-1">
                                            <label className="block text-[8px] font-medium text-gray-500 mb-2 uppercase tracking-wide">
                                                Number of Boxes
                                            </label>
                                            <input
                                                type="number"
                                                value={boxCount}
                                                onChange={(e) => setBoxCount(e.target.value)}
                                                className="w-full px-2.5 py-1.5 border border-gray-300 rounded-md text-[11px] text-black focus:outline-none focus:border-black"
                                                min="1"
                                                placeholder="Enter box count"
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* Submit */}
                                <button
                                    onClick={handleCreateRequest}
                                    disabled={isSubmitting}
                                    className={`w-full py-2 rounded-md font-semibold text-[11px] tracking-wide uppercase transition-all ${isSubmitting
                                        ? "bg-gray-300 cursor-not-allowed text-white"
                                        : "bg-red-600 hover:bg-gray-800 text-white"
                                        }`}
                                >
                                    {isSubmitting ? (
                                        <span className="flex items-center justify-center gap-2">
                                            <Loader2 className="w-3.5 h-3.5 animate-spin" />
                                            Creating...
                                        </span>
                                    ) : (
                                        "Create Pickup Request"
                                    )}
                                </button>

                            </div>
                        </div>

                        {/* Right Table */}
                        <div className="lg:col-span-1 w-full">
                            <div className="bg-white w-full rounded-xl border border-gray-200 overflow-hidden">
                                <div className="p-3">
                                    {loading ? (
                                        <div className="flex flex-col items-center justify-center py-20">
                                            <Loader2 className="w-8 h-8 text-black animate-spin mb-3" />
                                            <p className="text-gray-500 text-[11px]">Loading pickup requests...</p>
                                        </div>
                                    ) : pickupRequests.length > 0 ? (
                                        <>
                                            {/* Pickup Request Table */}
                                            <div className="overflow-x-auto max-h-[375px] overflow-y-auto custom-scrollbar">
                                                <table className="min-w-full divide-y divide-gray-100">
                                                    <thead className="bg-slate-800 sticky top-0">
                                                        <tr>
                                                            <th className="px-2.5 py-2 text-left text-[8px] font-semibold text-white uppercase tracking-wider">
                                                                Request ID
                                                            </th>
                                                            {/* <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                                                                Order ID
                                                            </th> */}
                                                            <th className="px-2.5 py-2 text-left text-[8px] font-semibold text-white uppercase tracking-wider">
                                                                Pickup ID
                                                            </th>
                                                            <th className="px-2.5 py-2 text-left text-[8px] font-semibold text-white uppercase tracking-wider">
                                                                Status
                                                            </th>
                                                            <th className="px-2.5 py-2 text-left text-[8px] font-semibold text-white uppercase tracking-wider">
                                                                Date
                                                            </th>
                                                            <th className="px-2.5 py-2 pl-4 text-left text-[8px] font-semibold text-white uppercase tracking-wider">
                                                                Time
                                                            </th>
                                                            <th className="px-2.5 py-2 text-left text-[8px] font-semibold text-white uppercase tracking-wider">
                                                                Boxes
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody className="bg-white divide-y divide-gray-100">
                                                        {pickupRequests.map((request) => (
                                                            <tr
                                                                key={request.id}
                                                                onClick={() => setSelectedRequest(request.request_id)}
                                                                className={`cursor-pointer transition-all ${selectedRequest === request.request_id
                                                                        ? "bg-gray-100"
                                                                        : "hover:bg-gray-50"
                                                                    }`}
                                                            >
                                                                <td className="px-2.5 py-2.5 text-[8px] font-medium text-black">
                                                                    {request.request_id}
                                                                </td>
                                                                {/* <td className="px-3 py-3 text-xs font-medium text-gray-900">
                                                                    {request.order_ids || '-'}
                                                                </td> */}
                                                                <td className="px-2.5 py-2.5 text-[8px] font-medium text-black">
                                                                    {request.pickup_id}
                                                                </td>
                                                                <td className="px-2.5 py-2.5">
                                                                    <span
                                                                        className={`px-1.5 py-0.5 inline-flex text-[8px] font-semibold rounded border ${getStatusColor(
                                                                            request.status
                                                                        )}`}
                                                                    >
                                                                        {request.status}
                                                                    </span>
                                                                </td>
                                                                <td className="px-2.5 py-2.5 text-[8px] text-gray-700">
                                                                    {request.pickup_date}
                                                                </td>
                                                                <td className="px-2.5 py-2.5 text-[8px] text-gray-700">
                                                                    {request.start_time}
                                                                </td>
                                                                <td className="px-2.5 py-2.5 text-[8px] text-center text-gray-700">
                                                                    {request.box_count}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>


                                            {/* Pagination */}
                                            {/* Pagination - Always visible */}
                                            <div className="flex items-center justify-between px-3 py-2.5 bg-gray-50 border-t border-gray-100 mt-3 rounded-md">
                                                <div className="text-[10px] text-gray-500">
                                                    Page {currentPage} of {totalPages}
                                                </div>
                                                <div className="flex gap-1.5">
                                                    <button
                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                        disabled={currentPage === 1}
                                                        className={`px-2.5 py-1 rounded text-[10px] font-medium transition-colors ${currentPage === 1
                                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                            : 'bg-black text-white hover:bg-gray-800'
                                                            }`}
                                                    >
                                                        Previous
                                                    </button>
                                                    <button
                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                        disabled={currentPage === totalPages}
                                                        className={`px-2.5 py-1 rounded text-[10px] font-medium transition-colors ${currentPage === totalPages
                                                            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                            : 'bg-red-600 text-white hover:bg-gray-800'
                                                            }`}
                                                    >
                                                        Next
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="flex flex-col items-center justify-center py-12">
                                            <Package className="w-8 h-8 text-gray-300 mb-2" />
                                            <p className="text-black text-[11px] font-medium">No pickup requests found</p>
                                            <p className="text-gray-400 text-[10px] mt-0.5">There are no pickup requests to display</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default PickupDetailsPage;